import CustomModal from 'components/DesignSystems/New/CustomModal';

type PremiumResourceManagementModalProps = {
  show: boolean;
  onClose: () => void;
};

export function PremiumResourceManagementModal({
  show,
  onClose,
}: PremiumResourceManagementModalProps) {
  return (
    <CustomModal
      show={show}
      onClose={onClose}
      onConfirm={onClose}
      heading="Upgrade for Premium Resource Management"
      saveButton="OK"
    >
      <p className="tw:m-0">
        Contact{' '}
        <a href="mailto:support@disastertech.com">support@disastertech.com</a>{' '}
        to subscribe.
      </p>
    </CustomModal>
  );
}
